import styled from 'styled-components';
import { Text } from '@visx/text';

export const BuyLimitWrapper = styled(Text)`
  ${({ theme }) => theme.typography.xSmallStrong}
  fill: ${({ theme }) => theme.color.chart01};
`;
